import { OrderItem } from "@/types";
import { sanitizeNumber } from "@/utils/numbers";

export const getOrderItemPrice = (dish: OrderItem): number => {
  const quantity = sanitizeNumber(dish.quantity, 1);
  const price = sanitizeNumber(dish.price);

  let unitPrice = price;

  if (!dish?.settings) {
    return (unitPrice = price);
  }

  dish.settings.forEach((s) => {
    (s?.options ?? []).forEach((o) => {
      const optionPrice = sanitizeNumber(o.price);
      unitPrice += optionPrice;
    });
  });

  return unitPrice * quantity;
};

export const getOrderDetails = (dish: OrderItem) => {
  if (!dish.settings) return;

  return dish.settings
    .map((s) => {
      return `${s.title}: ${s.options?.map((o) => o.title).join(", ")}.`;
    })
    .join(" ");
};

export const getOrderSubtotal = (dish: OrderItem[]): number => {
  return dish.reduce((total, item) => {
    return total + getOrderItemPrice(item);
  }, 0);
};

export const getOrderTaxes = (dish: OrderItem[]): number => {
  const fixedTax = 0.15;
  return dish.reduce((total, item) => {
    return total + getOrderItemPrice(item) * fixedTax;
  }, 0);
};

export const getOrderTips = (dish: OrderItem[]): number => {
  const fixedTip = 0.1;
  const subtotal = getOrderSubtotal(dish);
  return subtotal * fixedTip;
};

export const getOrderTotal = (dish: OrderItem[]): number => {
  const subtotal = getOrderSubtotal(dish);
  const taxes = getOrderTaxes(dish);
  return subtotal + taxes;
};
